<script>
import axios from 'axios';
import { useI18n } from 'vue-i18n';
import AppSelect from '../../shared/AppSelect.vue';

export default {
  components: { AppSelect },
  setup() {
    const i18n = useI18n();
    return {
      locale: i18n.locale
    };
  },
  data() {
    return {
      event_types: [],
    }
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    customClass: {
      type: [String, Object],
      default: ''
    }
  },
  emits: ['update:modelValue', 'change'],
  computed: {
    options() {
      return this.event_types.map((event_type) => ({
        value: String(event_type.id),
        label: event_type.name,
      }));
    },
    selectValue() {
      if (!this.modelValue) return '';
      const found = this.event_types.find(type =>
        type.id === this.modelValue ||
        type.key === this.modelValue ||
        String(type.id) === String(this.modelValue)
      );
      return found ? String(found.id) : String(this.modelValue);
    },
  },
  watch: {
    'locale.value': {
      handler() {
        this.getList();
      },
      immediate: false
    }
  },
  methods: {
    getList() {
      const url = "/api/dict/v1/event_types";
      let currentLocale = 'ru';
      if (this.locale) {
        currentLocale = (typeof this.locale === 'object' && 'value' in this.locale)
          ? this.locale.value
          : (this.locale || 'ru');
      }

      axios.get(url, {
        headers: {
          'Accept-Language': currentLocale
        }
      })
            .then(response => {
              this.event_types = response.data;
            })
            .catch(error => {
              console.error('Error loading event types:', error);
            });
    },
    onChange(value) {
      this.$emit('update:modelValue', value);
      this.$emit('change', value);
    }
  },
  beforeMount() {
    this.getList();
  }
}
</script>

<template>
  <AppSelect
    variant="events-form"
    :class="customClass"
    :model-value="selectValue"
    :options="options"
    placeholder=""
    @update:model-value="$emit('update:modelValue', $event)"
    @change="onChange"
  />
</template>
